const relationship = [
    "Select from the following...",
    "Spouse",
    "Child",
    "Parent",
    "Other Relative",
    "Other Non-relative",
]
export default relationship